import axios from "axios";
import * as CryptoJS from "crypto-js";

const randomString = () => Math.random().toString(36).slice(-8);

const formatString = (inputString: string, desiredLength: number, paddingChar: string): string => {
    let formattedString = inputString;
    while (formattedString.length < desiredLength) {
        formattedString += paddingChar;
    }
    return formattedString;
};

const configurationBaseURL = (URL: string) => {
    axios.defaults.baseURL = URL
}

const configurationHeaders = (publicKey: string) => {
    
	let apikey = publicKey == undefined ? "" : publicKey;
    let KEY = formatString(apikey.replace(/[-:;,._\\@/*&^%$#!()=+]/g, ""), 32, "0");
    let IV = formatString(
        `PT${randomString()}JAq113vgkeGWPkCEStbILNJCCUfaAgxk5${randomString()}q1EfBshryYLoedKxjDqxWKFRf6E${randomString()}ZUC5y0CNLWHaIDJU6ozwUVLao${randomString()}`.replace(
            /[-:;,._\\@/*&^%$#!()=+]/g,
            ""
        ),
        16,
        "0"
    );
	let key = CryptoJS.enc.Utf8.parse(KEY);
    let iv = CryptoJS.enc.Utf8.parse(IV);
    let encrypted;
    let srcs = CryptoJS.enc.Utf8.parse(publicKey);
    
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    // TODO
    axios.defaults.headers.common["public-key"] = encrypted.ciphertext.toString();
	axios.defaults.headers.common["www"] = IV;


    axios.defaults.headers.common["X-Api-Key"] = publicKey
};

export default {configurationHeaders, configurationBaseURL};
